import React from 'react';
import BaseIcon from './BaseIcon';

import { ReactComponent as IconPath } from 'assets/images/icons/extendedProfile/health-safety-icon.svg';

function HealthSafetyIcon(props) {
  return <BaseIcon SVGElement={IconPath} {...props} />;
}

export default HealthSafetyIcon;
